<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <v-sheet color="grey lighten-4" class="pa-4">
        <v-avatar
          class="mb-4"
          color="grey darken-1"
          size="64"
        ></v-avatar>
        <div>Hi, {{getUserName}}({{getUserEmail}})</div>
      </v-sheet>
      <v-divider></v-divider>
      <v-list
        v-if="!hasNotGotUserYet" 
        dense
      >
        <menu-list v-for="(group, index) in groups" :key="`group-${index}`" :group="group"></menu-list>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>{{getCurrentFunction}}</v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-toolbar-items>
      <v-btn text @click="logout">登出</v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <v-main>
      <v-container class="py-8 px-6" fluid>
          <div id="app">
            <router-view/>
          </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import MenuList from '@/components/layout/MenuList'
  import functions from '@/config/functions'
  export default {
    components: { MenuList },
    data: () => ({
      drawer: null,
      groups: functions
      
    }),
    async created(){
      if (this.hasNotGotUserYet){
        try{
          await this.fetchUserInfo(this.getUserToken);
        } catch (e) {
          this.$router.replace('/auth/login')
        }
      }
      else {
        console.log(this.getUserInformation, 'Default.vue, this.getUserInformation')
      }
      
    },
    computed:{
      greeting(){
        return this.$store.state.greeting;
      },
      ...mapGetters('auth',[
        'getUserToken',
        'getUserInformation',
        'getCurrentFunction',
      ]),
      
      UserInfo(){
        return this.getUserInformation;
      },
      hasNotGotUserYet () {
        //已登入，還沒有取得用戶資訊
        return ((this.getUserToken.length > 0) && (Object.keys(this.getUserInformation).length === 0))
      },
      getUserName(){
        return (Object.keys(this.getUserInformation).length === 0)? '': this.getUserInformation.user.name;
      },
      getUserEmail(){
        return (Object.keys(this.getUserInformation).length === 0)? '': this.getUserInformation.user.email;
      }
    },
    methods:{
      ...mapActions('auth',['fetchUserInfo','deleteBrowserStorage']),
      logout(){
        this.deleteBrowserStorage()
        this.$router.push({name: 'Login'})
      }
    },
    mounted(){
      
    }
  }
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
